import { combineReducers } from 'redux';
import i18nReducer from './i18nReducer';
import themesReducer from './themeReducer';
import settingsReducer from './settingsReducer';
import joyrideReducer from './joyrideReducer';
import userSettingsReducer from './userSettingsReducer';
import errorReducer from './errorReducer';
import chatReducer from './chatReducer';
import openAIIncidentsReducer from './openAIIncidentsReducer';
import chatlistReducer from './chatlistReducer';
import navigationHeaderReducer from './navigationHeaderReducer';
import modalReducer from './modalReducer';
import environmentReducer from './environmentReducer';
import messageSourceReducer from './messageSource';

const rootReducer = combineReducers({
    i18n: i18nReducer,
    themes: themesReducer,
    settings: settingsReducer,
    joyride: joyrideReducer,
    userSettings: userSettingsReducer,
    error: errorReducer,
    chats: chatReducer,
    openAIIncidents: openAIIncidentsReducer,
    chatlist: chatlistReducer,
    navHeader: navigationHeaderReducer,
    modal: modalReducer,
    environment: environmentReducer,
    messageSource: messageSourceReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
